"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserAuthenticationFailed = void 0;
var GuestUserAuthenticationFailed;
(function (GuestUserAuthenticationFailed) {
    GuestUserAuthenticationFailed["notActivated"] = "notActivated";
    GuestUserAuthenticationFailed["invalidEmailOrPassword"] = "invalidEmailOrPassword";
})(GuestUserAuthenticationFailed || (exports.GuestUserAuthenticationFailed = GuestUserAuthenticationFailed = {}));
//# sourceMappingURL=GuestUserAuthenticationFailed.js.map